import { makeStyles } from '@mui/styles';

import { StatisticWithLabelColoredProps } from './types';

export default makeStyles(() => ({
    mainContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '56px',
        width: '100%',
        borderLeft: (props: StatisticWithLabelColoredProps) => `12px solid ${props.sideColumnColor}`,
        borderRadius: '4px',
        fontSize: '0.75rem',
        backgroundColor: '#fff',
        color: '#000'
    },
    statValueContainer: { fontSize: '1rem' }
}));